// extracted by mini-css-extract-plugin
export default {"root":"company_root__+AsmD"};